<svelte:head>
  <title>Offers | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<table class="table is-fullwidth is-hoverable">
  <tbody>
    {#each items as item}
      <tr>
        <td style="width:90%">
          <div
            class="is-pulled-left"
            style="width:120px;height:120px;margin-right:20px;"
          >
            {#if item.data.images?.[0]}
              <img
                src={item.data.images[0]}
                style="height:120px;width:120px;object-fit:cover;object-position:center;"
                alt="item available"
              />
            {:else}
              <img
                src="/assets/img/box.png"
                style="height:120px;width:120px;background-color:lightgrey"
                alt="placeholder"
              />
            {/if}
          </div>
          <div>
            <a href={$url('../../../offer/' + item.id)}>{item.data.name}</a> 
            <span class="tag is-info is-light">{item.data.status || "draft"}</span>
          </div>
          <div class="is-line-clamp-4">
           {item.data.description}
          </div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<script lang="ts">
  import _ from "lodash";
  import { url, params } from "@sveltech/routify";

  let companyId = $params['id'];

  let items : Offer_v2_Doc[] = [];

  let firebase = window.firebase;

  getOffers();

  async function getOffers() {
    firebase
      .firestore()
      .collection("offers_v2")
      .where('company', '==', companyId)
      .onSnapshot((snap) => {
        items = snap.docs.map(doc => ({ id: doc.id, data: doc.data() } as Offer_v2_Doc)).sort((a, b) => b.data.created > a.data.created ? 1 : -1);
      });
  }

</script>
